// Visualization - Dream scenario of success
import FeedbackPage from '@/components/FeedbackPage'

export default function DreamScenarioPage() {
  return (
    <FeedbackPage emoji="✨" title="pages.onboarding.dreamScenario.title" />
  )
}
